module.exports = __webpack_public_path__ + "static/img/5en.fc04a9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/5en.png
// module id = AnQc
// module chunks = 0